export default __webpack_public_path__ + "img/homepage-competitive-cover.asset.5636612c.jpg";